import { Section } from '@ria-client/tw-shared-ui/layout/section';

export function UnderHeroLegalDisclosure() {
  return (
    <Section aria-label="Disclosure" className="py-4">
      <p className="typography-text-small text-muted-foreground">
        <strong>Disclosure:</strong> The data for NerdWallet’s Investment Advisor search tool is
        sourced from the U.S. Securities Exchange Commission Investment Adviser Public Disclosure
        (IAPD) database. NerdWallet does not create or control this data. We make no representations
        regarding its accuracy, completeness, reliability, or timeliness. Information may be
        incomplete, outdated, or subject to error. Results may include references or links to
        external websites or materials. We do not endorse and are not responsible for the content,
        accuracy, or practices of any third-party resources.
      </p>
    </Section>
  );
}
